// extracted by mini-css-extract-plugin
module.exports = {"contactsSection":"styles_contactsSection__j7Y3H","emailRow":"styles_emailRow__hYskY","supportBtn":"styles_supportBtn__iASfg"};